import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import lapi, { API, getLToken, setLToken, clearLToken } from "@/lib/listenerApi";
import { getToken as getAuthorToken } from "@/lib/api";

const ListenerContext = createContext(null);
export const useListener = () => useContext(ListenerContext);

export function ListenerProvider({ children }) {
  const [listener, setListener] = useState(undefined); // undefined=loading, null=none, obj=signed in

  const finish = (data, remember = true) => { setLToken(data.token, remember); setListener(data.listener); return data.listener; };

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Returning from Emergent Google auth: exchange the session_id, then clean the hash.
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      if (sid) {
        lapi.post("/listener/auth/google", { session_id: sid })
          .then((r) => { finish(r.data); })
          .catch(() => {})
          .finally(() => {
            try { window.history.replaceState(null, "", window.location.pathname + window.location.search); } catch { /* ignore */ }
          });
        return;
      }
    }
    const t = getLToken();
    if (!t) { setListener(null); return; }
    lapi.get("/listener/auth/me").then((r) => setListener(r.data)).catch(() => { clearLToken(); setListener(null); });
  }, []);

  const login = useCallback(async (email, password, remember = true) => finish((await lapi.post("/listener/auth/login", { email, password })).data, remember), []);
  const register = useCallback(async (email, password, name, remember = true) => finish((await lapi.post("/listener/auth/register", { email, password, name })).data, remember), []);
  const loginAsAuthor = useCallback(async () => {
    const t = getAuthorToken();
    if (!t) throw new Error("Not signed in as an author");
    const r = await axios.post(`${API}/listener/auth/from-author`, {}, { headers: { Authorization: `Bearer ${t}` } });
    return finish(r.data);
  }, []);
  const loginGoogle = useCallback((redirectTo) => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Return the listener to wherever they signed in from (e.g. mid-book on the Listen page),
    // unless a specific destination (like /library) was requested.
    const path = redirectTo || (window.location.pathname + window.location.search);
    const redirectUrl = window.location.origin + path;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }, []);
  const logout = useCallback(() => { clearLToken(); setListener(null); }, []);

  return (
    <ListenerContext.Provider value={{ listener, login, register, loginGoogle, loginAsAuthor, logout, setListener }}>
      {children}
    </ListenerContext.Provider>
  );
}

export default ListenerProvider;
